import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import currency2 from "assets/images/currency_2.svg";
import ca_commodity2 from "assets/images/ca_commodity2.svg";
import { LinkButton } from "components/buttons";
import { Link } from "react-router-dom";
import DepositImage from "assets/images/hero-images/Banner_Deposit.png";
import BG from "assets/images/hero-images/BG.png";

function CommodityMurabahahBiz2() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Deposits"
          title={`Commodity Murabahah Foreign Currency<br>
              <span className="jumbotron-subtitle-2">
                Current Account-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
          backgroundImage={DepositImage}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Maximize your international business potential with our Foreign
              Currency Current Account-<em>i</em>. Enjoy competitive profit
              rates that generate returns on your deposits while
              ensuring liquidity for operational needs. Open your account today
              and advance your business.
            </p>
            <img
              style={{ width: "100%" }}
              src={currency2}
              className="d-inline-block align-top"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Attractive Profit Rates</div>
                <div className="column-subheader">
                  Earn attractive returns under simple tier rates{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Minimum Balance</div>
                <div className="column-subheader">
                  No minimum balance to maintain{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial Deposit</div>
                <div className="column-subheader">
                  USD5,000 or its equivalent{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Shariah Contract</div>
                <div className="column-subheader">
                  Commodity Murabahah (via Tawarruq arrangement){" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Expand your opportunities overseas{" "}
                </div>
                <div className="column-subheader-2">
                  With an account that hedges against foreign currency
                  fluctuations as they keep it for future use{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Protected by PIDM</div>
                <div className="column-subheader-2">
                  Protected by PIDM up to RM250,000 for each depositor{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4"></div>
          <div className="col-xl-8">
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <LinkButton
                text="Product Disclosure Sheet (ENG)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/ENG PDS CM FCY CA-i (1).pdf"
                  )
                }
              />
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/fees_and_charges.pdf"
                  )
                }
              />
              {/* <LinkButton
                text="Product Disclosure Sheet (BM)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/ENG PDS CM FCY CA-i (1).pdf"
                  )
                }
              /> */}
              <LinkButton
                text="Profit Rates"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/CMCA FCY Profit Rate_16052023.pdf"
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default CommodityMurabahahBiz2;
